import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function EngagementPage() {
  const navigate = useNavigate();

  const handleAccept = () => {
    localStorage.setItem('engagement_accepted', 'true');
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-4 py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="max-w-lg w-full text-center"
      >
        <div className="bg-white rounded-3xl shadow-[0_10px_60px_rgba(44,53,49,0.06)] border border-[#EBE7E0] p-8 sm:p-12">
          <div className="space-y-6" style={{ fontFamily: 'Manrope' }}>
            <p className="text-[#2C3531] text-lg leading-relaxed">
              Cette application ne vous demande pas d'être régulier(e), parfait(e), motivé(e) ou discipliné(e).
            </p>
            <p className="text-[#2C3531] text-lg leading-relaxed">
              Elle vous demande seulement ceci :
            </p>
            <p className="text-[#2C3531] text-lg leading-relaxed font-medium">
              quand ça déborde, ouvrez-la avant de rester seul(e) avec ce qui se passe.
            </p>
          </div>

          <div className="mt-10">
            <button
              onClick={handleAccept}
              className="w-full py-4 bg-[#6B8576] text-white rounded-full font-medium hover:bg-[#546A5E] transition-all duration-300 text-sm"
              data-testid="engagement-accept"
            >
              D'accord, je l'utiliserai au moins une fois quand ça déborde.
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
